import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { RxjsService } from '@app/shared';
import { ScrollPanel } from 'primeng/scrollpanel';

@Component({
  selector: 'app-page-quick-action',
  templateUrl: './page-quick-action.component.html',
  styleUrls: ['./page-quick-action.component.scss']
})
export class PageQuickActionComponent implements OnInit {

  isnavExpand: boolean;
  @Input() formData: any = {};
  @ViewChild('quickaction_sidebar', { static: false }) quickActionSidebar: ElementRef;
  @ViewChild('quickaction_menu', { static: false }) quickActionMenu: ElementRef;
  @Input() actionTabList: any;
  @Input() height: any = '40vh';
  @Input() template = 1;
  @Input() fromComponent: string;
  @Output() actionClicked = new EventEmitter<any>();
  @Output() navClicked = new EventEmitter<any>();
  @ViewChild('pageScrollBar', { static: false }) chatScrollBar: ScrollPanel;

  constructor(private rxjsService: RxjsService) { }

  ngOnInit(): void {
    console.log('PageQuickActionComponent ngOnInit - actionTabList:', this.actionTabList);
  }

  ngAfterViewInit() {
    if (this.template == 2) {
      this.rxjsService.getToggleQuickActionComponent().subscribe((res) => {
        if (res) {
          this.quickActionSidebar.nativeElement.classList = 'quick-action-sidebar';
        } else {
          this.quickActionSidebar.nativeElement.classList = 'hide-quick-action-menu quick-action-sidebar';
        }
      })
    }
    if (this.template == 1) {
      this.rxjsService.getQuickActionClose().subscribe((res) => {
        if (res) {
          this.closeNav();
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.actionTabList?.currentValue != changes?.actionTabList?.previousValue) {
      this.actionTabList = this.actionTabList;
    }
    console.log('PageQuickActionComponent ngOnChanges - actionTabList:', this.actionTabList);
  }

  openNav() {
    if (this.isnavExpand) {
      this.navClicked.emit({ type: 'open' });
      this.quickActionSidebar.nativeElement.style.width = "312px";
    } else {
      this.navClicked.emit({ type: 'close' });
      this.quickActionSidebar.nativeElement.style.width = "0px";
    }
    this.quickActionMenu.nativeElement.style.right = "12px";
    this.quickActionMenu.nativeElement.style.visibility = "visible";
    this.isnavExpand = !this.isnavExpand;
  }

  closeNav() {
    if (this.template == 2) {
      this.navClicked.emit({ type: 'close' });
      return this.quickActionSidebar.nativeElement.classList = 'hide-quick-action-menu quick-action-sidebar';
    }
    this.quickActionSidebar.nativeElement.style.width = "0";
    this.quickActionMenu.nativeElement.style.right = "0";
    this.quickActionMenu.nativeElement.style.visibility = "hidden";
    this.isnavExpand = !this.isnavExpand;
    this.navClicked.emit({ type: 'close' });
  }

  onActionTabClicked(action, i) {
    this.actionTabList?.columns?.map(el => {
      if (el?.id == i) {
        el.isSelected = true;
      } else {
        el.isSelected = false;
      }
      return el;
    });
    this.actionClicked.emit({ type: action, index: i, fromComponent: this.fromComponent });
  }

  onchangeCheckbox(action, type) {
    this.actionClicked.emit({ value: action, type: type });
  }

  // Method to programmatically open the Quick Action menu
  openQuickActionMenu() {
    console.log('Opening Quick Action menu programmatically');
    if (this.quickActionSidebar) {
      this.quickActionSidebar.nativeElement.style.display = 'block';
    }
  }

  ngDestroy() {
    this.rxjsService.setToggleQuickActionComponent(null);
  }
}
